const UserGuide = [
    {
        path: '/user-guide',
        name: 'UserGuide',
        component: () => import('@/views/pages/Silvia/Guides/UserGuide')
    },
];

export default UserGuide;
